import axios from 'axios'
import store from '../store/app'

// 创建axios实例
const service = axios.create({
        baseURL: process.env.BASE_URL, // api的base_url
        timeout: 50000 // 请求超时时间
    })
    // console.log('process.env.BASE_URL',process.env.BASE_URL)
    // request拦截器 axios的一些配置
service.interceptors.request.use(config => {
    // 判断是否存在token，如果存在的话，则每个http header都加上Access-Token
    if (store.state.token) {
        config.headers['Access-Token'] = store.state.token;
    }
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器 axios的一些配置
service.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/libs/http.js